module.exports = __webpack_public_path__ + "img/habit_logo.d8def496.png";